const findContactWithKey = (contacts, key) => contacts?.find((contact) => contact[key])?.[key] ?? undefined;

export default findContactWithKey;
